(() => {
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const GALLERY_SELECTOR = '.card-gallery';
  const OVERLAY_CLASS = 'khushi-product-card-hover-overlay';
  const IMAGE_CLASS = 'khushi-product-card-hover-overlay__image';
  const FALLBACK_CLEANUP_MS = 500;

  function supportsTransition(event, gallery) {
    if (!FINE_POINTER.matches || REDUCED_MOTION.matches) return false;
    if (event.pointerType && event.pointerType !== 'mouse') return false;
    if (!(gallery instanceof HTMLElement)) return false;

    // Only enhance Horizon's native second-image hover behavior. If the merchant
    // disables that setting, Khushi adds no hover behavior of its own.
    return gallery.getAttribute('on:pointerenter') === '/previewImage';
  }

  function boundaryGallery(event) {
    const target = event.target instanceof Element ? event.target : null;
    const gallery = target?.closest(GALLERY_SELECTOR);
    if (!(gallery instanceof HTMLElement)) return null;

    // pointerover/pointerout bubble for every descendant. Only act when crossing
    // the actual gallery boundary, not while moving between controls/images inside it.
    const related = event.relatedTarget instanceof Node ? event.relatedTarget : null;
    if (related && gallery.contains(related)) return null;
    return gallery;
  }

  function activeImage(gallery) {
    const activeSlide = gallery.querySelector(
      'slideshow-component slideshow-slide[aria-hidden="false"]:not([hidden])'
    );
    if (!(activeSlide instanceof HTMLElement)) return null;

    const image = activeSlide.querySelector('.product-media__image, img');
    return image instanceof HTMLImageElement ? image : null;
  }

  function clearOverlay(host) {
    host.querySelectorAll(`:scope > .${OVERLAY_CLASS}`).forEach((overlay) => overlay.remove());
  }

  function snapshotCurrentImage(gallery) {
    const slideshow = gallery.querySelector('slideshow-component');
    const host = slideshow?.querySelector(':scope > slideshow-container');
    const source = activeImage(gallery);

    if (!(host instanceof HTMLElement) || !(source instanceof HTMLImageElement)) return;
    if (!source.complete || source.naturalWidth === 0) return;

    clearOverlay(host);

    const sourceStyles = getComputedStyle(source);
    const hostStyles = getComputedStyle(host);
    const overlay = document.createElement('span');
    const image = document.createElement('img');

    overlay.className = OVERLAY_CLASS;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundColor = hostStyles.backgroundColor;

    image.className = IMAGE_CLASS;
    image.alt = '';
    image.src = source.currentSrc || source.src;
    image.decoding = 'async';
    image.draggable = false;
    image.style.objectFit = sourceStyles.objectFit;
    image.style.objectPosition = sourceStyles.objectPosition;
    image.style.backgroundColor = sourceStyles.backgroundColor;

    overlay.appendChild(image);
    host.appendChild(overlay);

    let removed = false;
    const remove = () => {
      if (removed) return;
      removed = true;
      overlay.remove();
    };

    overlay.addEventListener('animationend', remove, { once: true });
    window.setTimeout(remove, FALLBACK_CLEANUP_MS);
  }

  function handleBoundary(event) {
    const gallery = boundaryGallery(event);
    if (!supportsTransition(event, gallery)) return;

    // pointerover happens before pointerenter and pointerout before pointerleave.
    // Snapshotting here preserves the currently visible image before Horizon's
    // native /previewImage or /resetImage handler performs its instant selection.
    // The overlay then fades away to reveal whatever Horizon selected underneath.
    snapshotCurrentImage(gallery);
  }

  document.addEventListener('pointerover', handleBoundary, true);
  document.addEventListener('pointerout', handleBoundary, true);
})();
